import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PendingSignaturesPanelComponent } from './pages/pending-signatures-panel/pending-signatures-panel.component';

const routes: Routes = [
  { path: '', component: PendingSignaturesPanelComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: []
})
export class PendingSignaturesPanelRoutingModule {}
